import React from "react";
import CategoryPageTemplate from "../CategoryPageTemplate";
import { categoryPageConfigs } from "../categoryPageConfigs";

export default function FloralTools() {
  return <CategoryPageTemplate {...categoryPageConfigs.floralTools} />;
}
